import React from "react";
import { Link } from "react-router-dom";
import { useData } from "../context/DataContext";
import Seo from "./Seo";
import { Store, Loader2 } from "lucide-react";

/** Hides every public shop page while the school prepares the catalogue. */
export const ShopGate = ({ children }) => {
  const { settings, loaded } = useData();

  if (!loaded && !settings) {
    return <div className="py-24 text-center text-stone-400"><Loader2 className="animate-spin inline" size={22} /></div>;
  }
  if (settings?.shopEnabled) return children;

  return (
    <div className="max-w-xl mx-auto px-6 py-24 text-center" data-testid="shop-closed">
      <Seo title="Boutique" description="La boutique de l'école ouvrira prochainement." />
      <Store size={34} className="mx-auto text-blush mb-5" />
      <h1 className="font-serif-display text-3xl text-stone-800">La boutique arrive bientôt</h1>
      <p className="text-stone-600 mt-3">
        Nous préparons nos goodies aux couleurs de l&apos;école. Revenez très vite&nbsp;!
      </p>
      <Link to="/" className="inline-block mt-8 bg-coral text-white px-6 py-3 rounded-full text-sm tracking-widest uppercase" data-testid="shop-closed-home">
        Retour à l&apos;accueil
      </Link>
    </div>
  );
};

export default ShopGate;
